import React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Copyright from './copyright';

const footerLinks = [
  /* {
    title: 'Company',
    description: [
      { id: 1, name: 'Resource', url: 'https://tea.texas.gov/' },
      { id: 2, name: 'Resource', url: 'https://tea.texas.gov/' },
    ],
  }, */
  {
    title: 'School Reports',
    description: [
      { id: 1, name: 'Enrollment Trends', url: '#' },
      { id: 2, name: 'Ratings Trends', url: '#' },
      { id: 3, name: 'Salary Trends', url: '#' },
      { id: 4, name: 'Superintendent Salary', url: '/school/super-salary' },
    ],
  },
  {
    title: 'City Reports',
    description: [
      { id: 1, name: 'Tax Rate Trends', url: '#' },
      { id: 2, name: 'Tax Rate Report', url: '#' },
    ],
  },
  {
    title: 'Resources',
    description: [
      { id: 1, name: 'Texas Education Agency (TEA)', url: 'https://tea.texas.gov/' },
      { id: 2, name: 'Texas Comptroller of Public Accounts', url: 'https://comptroller.texas.gov/' },
    ],
  },
  {
    title: 'Legal',
    description: [
      { id: 1, name: 'Privacy policy', url: '/legal/privacy-policy' },
    ],
  },
];

export default function AppFooter(props) {
  /* return <Copyright sx={{ pt: 4 }} />; */
  return (
    <Container
      maxWidth='xl'
      component='footer'
      sx={{
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        mt: 8,
        py: [2, 5],
      }}
    >
      <Grid container spacing={2} justifyContent='space-evenly'>
        {footerLinks.map((footerLink) => (
          <Grid item xs={6} sm={3} md={2} key={footerLink.title}>
            <Typography variant='h6' color='text.primary' gutterBottom>
              {footerLink.title}
            </Typography>
            <ul>
              {footerLink.description.map((item) => (
                <li key={item.Grid}>
                  <Link href={item.url} variant='subtitle1' color='text.secondary' underline='none'>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </Grid>
        ))}
      </Grid>
      <Copyright sx={{ pt: 4 }} />
    </Container>
  );
}
